"use strict";
/**
 * @module kung-fu/components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAudioPlayer = exports.AudioPlayer = void 0;
/**
 * AudioPlayer - A class for creating customizable audio players with playlist support
 *
 * @export
 * @class AudioPlayer
 */
class AudioPlayer {
    /**
     * Creates an instance of AudioPlayer.
     * Initializes the audio player with the specified container and default source.
     *
     * @param {AudioPlayerOptions} opts - Configuration options
     * @memberof AudioPlayer
     * @throws {Error} If the container or audio element cannot be found
     */
    constructor(opts) {
        this._opts = opts;
        const { ContainerID, DefaultSource } = this._opts;
        const audioContainer = document.querySelector(`#${ContainerID}`);
        const audioPlayer = audioContainer.querySelector('audio');
        if (DefaultSource != null) {
            audioPlayer.src = DefaultSource;
        }
        if (audioPlayer.controls == null) {
            audioPlayer.controls = true;
        }
        audioPlayer.style.display = 'block';
        this._audioContainer = audioContainer;
    }
    /**
     * Adds playlist functionality to the audio player
     * Sets up click event listeners on playlist items to switch audio sources
     * and update audio player elements (cover image, title, date, summary)
     *
     * @param {string} playlistID - The ID of the playlist container element (without the # prefix)
     * @returns {void}
     * @memberof AudioPlayer
     * @throws {Error} If the playlist element cannot be found
     */
    withPlaylist(playlistID) {
        const self = this;
        const audioPlayer = self._audioContainer.querySelector('audio');
        const playlist = document.querySelector(`#${playlistID}`);
        const anchorNodes = playlist.querySelectorAll('dt');
        const anchors = Array.from(anchorNodes);
        anchors.forEach((anchor) => {
            anchor.addEventListener('click', function () {
                const source = anchor.getAttribute('data-source');
                const img = anchor.getAttribute('data-cover-img');
                const title = anchor.getAttribute('data-title') || anchor.innerText;
                const pubDate = anchor.getAttribute('data-pub');
                const summary = anchor.getAttribute('data-summary');
                audioPlayer.pause();
                audioPlayer.src = source;
                const audioPlayerCover = self._audioContainer.querySelector('#audio-player-cover');
                if (audioPlayerCover) {
                    const coverImage = document.createElement('img');
                    coverImage.src = img;
                    coverImage.title = title;
                    coverImage.alt = title;
                    audioPlayerCover.innerHTML = '';
                    audioPlayerCover.appendChild(coverImage);
                }
                const audioPlayerTitle = self._audioContainer.querySelector('#audio-player-title');
                if (audioPlayerTitle) {
                    audioPlayerTitle.innerText = title;
                }
                const audioPlayerDate = self._audioContainer.querySelector('#audio-player-date');
                if (audioPlayerDate) {
                    audioPlayerDate.innerText = pubDate;
                }
                const audioPlayerSummary = self._audioContainer.querySelector('#audio-player-summary');
                if (audioPlayerSummary) {
                    audioPlayerSummary.innerText = summary;
                }
                audioPlayer.play();
            });
        });
    }
}
exports.AudioPlayer = AudioPlayer;
/**
 * Factory function to create an AudioPlayer instance
 *
 * @export
 * @param {string} audioContainerID - ID of the container element (without the # prefix)
 * @param {string} [defaultSource] - Optional default audio source URL
 * @returns {AudioPlayer} A new AudioPlayer instance
 */
const createAudioPlayer = (audioContainerID, defaultSource) => {
    return new AudioPlayer({ ContainerID: audioContainerID, DefaultSource: defaultSource });
};
exports.createAudioPlayer = createAudioPlayer;
//# sourceMappingURL=audio.js.map